import React from 'react';
import { JobCardDataProvider } from './JobCardDataContext';
const ContextProvider = ({ children }) => {
  return (
    <JobCardDataProvider>
      
        {children}
       
    </JobCardDataProvider>
  );
};

export default ContextProvider;